(function () {
  var BREVO_API_KEY = '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';

  var TEMPLATE_IDS = {
    'fr': 1,
    'en': 2,
    'de': 3,
    'es': 4,
    'nl': 5
  };

  function getLang() {
    var path = window.location.pathname;
    if (path.indexOf('/en/') !== -1 || path.indexOf('request-a-quote') !== -1) return 'en';
    if (path.indexOf('/de/') !== -1 || path.indexOf('angebot') !== -1) return 'de';
    if (path.indexOf('/es/') !== -1 || path.indexOf('solicitar') !== -1) return 'es';
    if (path.indexOf('/nl/') !== -1 || path.indexOf('offerte') !== -1) return 'nl';
    return 'fr';
  }

  function sendAccuseReception(prenom, email) {
    var lang = getLang();
    var templateId = TEMPLATE_IDS[lang] || 1;
    fetch('https://api.brevo.com/v3/smtp/email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'api-key': BREVO_API_KEY },
      body: JSON.stringify({
        to: [{ email: email, name: prenom }],
        templateId: templateId,
        params: { PRENOM: prenom }
      })
    });
  }

  if (window.location.hash === '#contact_form') {
    var form    = document.getElementById('ec-devis-form');
    var success = document.getElementById('ec-success');
    var hero    = document.getElementById('ec-hero');
    if (form && success) {
      form.style.display    = 'none';
      success.style.display = 'block';
      if (hero) hero.style.display = 'none';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  var form = document.getElementById('ec-devis-form');
  if (form) {
    form.addEventListener('submit', function () {
      var prenom = form.querySelector('[name="contact[first_name]"]');
      var email  = form.querySelector('[name="contact[email]"]');
      if (prenom && email && email.value) {
        sendAccuseReception(prenom.value || 'Client', email.value);
      }
    });
  }
})();